export default {
    tenants: state => {
        return state.tenants.length ? state.tenants.filter((item) => { return process.env.VUE_APP_ORIGIN_BACKOFFICE && process.env.VUE_APP_ORIGIN_BACKOFFICE === 'true' || !item.deleted_at}) : state.tenants;
    },
    currentTenant: state => {
        return state.currentTenant;
    },
    paginatedTenants: state => {
        return state.paginatedTenants;
    },
    countPerPool: state => {
        return state.countPerPool;
    },
}